'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { BlogCard } from './blog-card';

export const BlogSwiper = ({ blogs }: { blogs: Blog[] }) => {
  return (
    <Swiper
      pagination={true}
      modules={[Pagination]}
      spaceBetween={16}
      slidesPerView={1.1}
      breakpoints={{
        1024: {
          slidesPerView: 2,
          spaceBetween: 48,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 32,
        },
        480: {
          slidesPerView: 1.1,
          spaceBetween: 24,
        },
      }}
      className={cn('custom-container', 'mySwiper', ' ea-blog-swiper__container', '!pb-10 md:pb-0')}
    >
      {blogs.map(blog => (
        <SwiperSlide key={blog.slug} className="w-full">
          <BlogCard blog={blog} key={blog.slug} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
